import { render, staticRenderFns } from "./transfer-goods-list.vue?vue&type=template&id=a8454e18&scoped=true&"
import script from "./transfer-goods-list.vue?vue&type=script&lang=js&"
export * from "./transfer-goods-list.vue?vue&type=script&lang=js&"
import style0 from "./transfer-goods-list.vue?vue&type=style&index=0&id=a8454e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8454e18",
  null
  
)

export default component.exports